export default "__VITE_ASSET__be03bfac__"